module.exports = __webpack_public_path__ + "img/new_logo.2c8fb943.png";